// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-categories-block {
    float: left;
    width: 16%;
    position: relative;
}


.select-categories-block ul {
    padding: 0;
    margin: 0;
    border-radius: 4px;
    position: relative;
    width: calc(100% - 10px);
    display: block;
    max-height: 400px;
    overflow-y: scroll;
}

.select-categories-block li {
    display: block;
    color: rgb(63, 63, 63);
    font-size: 14px;
    overflow-wrap: break-word;
    cursor: pointer;
    list-style-type: none;
    border-bottom: 1px solid rgb(223, 223, 223);
    padding: 12px 16px;
    background-color: #ffffff;
}

.select-categories-block li:last-child {
    box-shadow: rgba(208, 208, 208, 0.5) 0 -1px 3px 0;
}

li.selected-category {
    background-color: #47a0fb !important;
    color: #ffffff;
}

li.selected-category-sscat {
    background-color: #28a745 !important;
    color: #ffffff;
}

.categories-block {
    padding: 10px;
}

.catalog-files-upload-container {
    background-color: #f1f2f4;
    min-height: calc(100vh);
    padding: 30px 15px 10px;
}

.category-left-arrow {
    position: absolute;
    top: 15px;
    left: -7px;
    box-shadow: rgba(208, 208, 208, 0.5) -2px 2px 1px -1px;
    transform: rotate(45deg);
    z-index: 100;
    border-top: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid rgb(255, 255, 255);
    border-left: 7px solid rgb(255, 255, 255);
}

li.selected-category {
    background-color: #47a0fb !important;
    color: #ffffff;
}

.sscat-view{
    background-color: #f1f2f4;
    padding: 30px 15px 10px;
    /* margin-left: -180px; */
}

.excel-upload-sidebar-items{
    background-color: #ffffff;
    margin-bottom: 0.5em;
    padding: 0.5em;
    display: flex;
    align-items: center;
    justify-content: center;
}

.categorySelected{
    background-color: #28a745 !important;
    color: #ffffff;
}

.excel-upload-sidebar-items:hover{
    background-color: #616161;
    cursor: pointer;
    color: #ffffff;
}

.excel-upload-panel{
    width: 100%;
    background: #f1f1f1;
    display: flex;
    height: calc(100vh);
}

.properties-sidebar{
    width: 20%;
    padding: 1em;
    border-right: 5px solid #ffffff;
}


.component-sidebar{
    width: 80%;
    padding: 1em;
}

.width-40{
    width: 40%;
}

.template-download-container {
    margin: 50px 0 30px;
    text-align: center;
}

.template-download-text {
    text-align: center;
    font-weight: bold;
}

.template-download-button {
    margin-top: 10px;
    background: #f45b69;
    font-size: 14px;
    color: #fff !important;
    font-weight: 700;
    padding: 12px 5px;
    border-radius: 0;
    text-align: center;
    cursor: pointer;
    outline: none !important;
    display: inline-block;
    width: 50%;
    text-decoration: none !important;
    border: none;
}

.flex-center{
    display: flex;
    justify-content: center;
    align-items: center;
}

.opacityReduce{
    opacity: 0.5;
}

.uploadFileContainer{
    position: relative;
    width: 100%;
    margin: auto;
    overflow: hidden;
    cursor: pointer;
    background: white;
}

.emptyGenericFile{
    padding: 40px 0;
    text-align: center;
    /* width: 150px; */
    /* border: 1px solid #ededed; */
    border-bottom-width: 3px;
    border-left-width: 2px;
    cursor: pointer;
    opacity: 0.9;
    color: #888888;
    overflow: hidden;
}

.excelUploadHeading{
    margin-top: 10px;
    border-bottom: 1px solid #eeeeee;
    padding: 0em 1em 0.5em 1em;
    font-size: 30px;
    margin-bottom: 10px;
}

.excel-upload-message{
    background-color: #ffffff;
    margin-bottom: 0.5em;
    padding: 0.5em;
    display: flex;
    align-items: center;
    justify-content: center;
}

.excel-upload-buttons{
    align-items: center;
    display: flex;
    justify-content: space-around;
}

.uploaded-files-filter{
    margin-bottom: 1em;
    display: flex;
    align-items: center;
}

.file-status-filter {
    margin: 13px 0 15px 0;
}

.excel-upload-rbac-btn-wrapper {
    display: flex;
    justify-content: flex-end;
    padding: 16px 16px 0 0;
}
`, "",{"version":3,"sources":["webpack://./client/components/styles/excelUpload.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;;AAGA;IACI,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,sDAAsD;IACtD,wBAAwB;IACxB,YAAY;IACZ,iCAAiC;IACjC,mCAAmC;IACnC,2CAA2C;IAC3C,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,+BAA+B;AACnC;;;AAGA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,UAAU;IACV,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,wBAAwB;IACxB,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;AAC1B","sourcesContent":[".select-categories-block {\n    float: left;\n    width: 16%;\n    position: relative;\n}\n\n\n.select-categories-block ul {\n    padding: 0;\n    margin: 0;\n    border-radius: 4px;\n    position: relative;\n    width: calc(100% - 10px);\n    display: block;\n    max-height: 400px;\n    overflow-y: scroll;\n}\n\n.select-categories-block li {\n    display: block;\n    color: rgb(63, 63, 63);\n    font-size: 14px;\n    overflow-wrap: break-word;\n    cursor: pointer;\n    list-style-type: none;\n    border-bottom: 1px solid rgb(223, 223, 223);\n    padding: 12px 16px;\n    background-color: #ffffff;\n}\n\n.select-categories-block li:last-child {\n    box-shadow: rgba(208, 208, 208, 0.5) 0 -1px 3px 0;\n}\n\nli.selected-category {\n    background-color: #47a0fb !important;\n    color: #ffffff;\n}\n\nli.selected-category-sscat {\n    background-color: #28a745 !important;\n    color: #ffffff;\n}\n\n.categories-block {\n    padding: 10px;\n}\n\n.catalog-files-upload-container {\n    background-color: #f1f2f4;\n    min-height: calc(100vh);\n    padding: 30px 15px 10px;\n}\n\n.category-left-arrow {\n    position: absolute;\n    top: 15px;\n    left: -7px;\n    box-shadow: rgba(208, 208, 208, 0.5) -2px 2px 1px -1px;\n    transform: rotate(45deg);\n    z-index: 100;\n    border-top: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid rgb(255, 255, 255);\n    border-left: 7px solid rgb(255, 255, 255);\n}\n\nli.selected-category {\n    background-color: #47a0fb !important;\n    color: #ffffff;\n}\n\n.sscat-view{\n    background-color: #f1f2f4;\n    padding: 30px 15px 10px;\n    /* margin-left: -180px; */\n}\n\n.excel-upload-sidebar-items{\n    background-color: #ffffff;\n    margin-bottom: 0.5em;\n    padding: 0.5em;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.categorySelected{\n    background-color: #28a745 !important;\n    color: #ffffff;\n}\n\n.excel-upload-sidebar-items:hover{\n    background-color: #616161;\n    cursor: pointer;\n    color: #ffffff;\n}\n\n.excel-upload-panel{\n    width: 100%;\n    background: #f1f1f1;\n    display: flex;\n    height: calc(100vh);\n}\n\n.properties-sidebar{\n    width: 20%;\n    padding: 1em;\n    border-right: 5px solid #ffffff;\n}\n\n\n.component-sidebar{\n    width: 80%;\n    padding: 1em;\n}\n\n.width-40{\n    width: 40%;\n}\n\n.template-download-container {\n    margin: 50px 0 30px;\n    text-align: center;\n}\n\n.template-download-text {\n    text-align: center;\n    font-weight: bold;\n}\n\n.template-download-button {\n    margin-top: 10px;\n    background: #f45b69;\n    font-size: 14px;\n    color: #fff !important;\n    font-weight: 700;\n    padding: 12px 5px;\n    border-radius: 0;\n    text-align: center;\n    cursor: pointer;\n    outline: none !important;\n    display: inline-block;\n    width: 50%;\n    text-decoration: none !important;\n    border: none;\n}\n\n.flex-center{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.opacityReduce{\n    opacity: 0.5;\n}\n\n.uploadFileContainer{\n    position: relative;\n    width: 100%;\n    margin: auto;\n    overflow: hidden;\n    cursor: pointer;\n    background: white;\n}\n\n.emptyGenericFile{\n    padding: 40px 0;\n    text-align: center;\n    /* width: 150px; */\n    /* border: 1px solid #ededed; */\n    border-bottom-width: 3px;\n    border-left-width: 2px;\n    cursor: pointer;\n    opacity: 0.9;\n    color: #888888;\n    overflow: hidden;\n}\n\n.excelUploadHeading{\n    margin-top: 10px;\n    border-bottom: 1px solid #eeeeee;\n    padding: 0em 1em 0.5em 1em;\n    font-size: 30px;\n    margin-bottom: 10px;\n}\n\n.excel-upload-message{\n    background-color: #ffffff;\n    margin-bottom: 0.5em;\n    padding: 0.5em;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.excel-upload-buttons{\n    align-items: center;\n    display: flex;\n    justify-content: space-around;\n}\n\n.uploaded-files-filter{\n    margin-bottom: 1em;\n    display: flex;\n    align-items: center;\n}\n\n.file-status-filter {\n    margin: 13px 0 15px 0;\n}\n\n.excel-upload-rbac-btn-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    padding: 16px 16px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
